import React, { useEffect, useState } from "react";
import { CalendarDays, Clock3, Maximize2, Minimize2, Timer } from "lucide-react";

const formatDate = (date, compact = false) =>
  new Intl.DateTimeFormat("fr-FR", compact
    ? { day: "2-digit", month: "2-digit" }
    : { weekday: "short", day: "numeric", month: "short" }).format(date);

const formatTime = (date) =>
  new Intl.DateTimeFormat("fr-FR", { hour: "2-digit", minute: "2-digit" }).format(date);

export const KdsCompactClock = ({ averageMinutes = null }) => {
  const [now, setNow] = useState(() => new Date());

  useEffect(() => {
    const timer = window.setInterval(() => setNow(new Date()), 30000);
    return () => window.clearInterval(timer);
  }, []);

  return (
    <div className="inline-flex max-w-full items-center gap-2 rounded-2xl border border-white/25 bg-white/10 px-3 py-2 text-white shadow-[0_6px_18px_rgba(0,0,0,0.16)]">
      <CalendarDays className="hidden h-4 w-4 shrink-0 text-amber-200 sm:block" />
      <span className="hidden whitespace-nowrap text-sm font-semibold sm:inline">
        {formatDate(now)}
      </span>
      <span className="whitespace-nowrap text-sm font-semibold sm:hidden">
        {formatDate(now, true)}
      </span>
      <span className="text-white/45">·</span>
      <Clock3 className="hidden h-4 w-4 shrink-0 text-amber-200 sm:block" />
      <span className="whitespace-nowrap text-sm font-semibold">{formatTime(now)}</span>
      <span className="text-white/45">·</span>
      <Timer className="h-4 w-4 shrink-0 text-amber-200" />
      <span className="whitespace-nowrap text-sm font-semibold">
        <span className="hidden sm:inline">Prépa moy. </span>
        {averageMinutes == null ? "—" : `${averageMinutes} min`}
      </span>
    </div>
  );
};
export const KdsFullscreenButton = ({ onBeforeToggle }) => {
  const [fullscreen, setFullscreen] = useState(() => Boolean(document.fullscreenElement));

  useEffect(() => {
    const sync = () => setFullscreen(Boolean(document.fullscreenElement));
    document.addEventListener("fullscreenchange", sync);
    return () => document.removeEventListener("fullscreenchange", sync);
  }, []);

  const toggle = async () => {
    onBeforeToggle?.();
    try {
      if (document.fullscreenElement) await document.exitFullscreen();
      else await document.documentElement.requestFullscreen();
    } catch {
      // Le navigateur peut refuser le plein écran; l'écran KDS reste utilisable.
    }
  };

  const Icon = fullscreen ? Minimize2 : Maximize2;
  return (
    <button
      type="button"
      onClick={toggle}
      className="rounded-2xl border border-white/20 bg-white/10 p-2.5 text-white transition hover:bg-white/15"
      title={fullscreen ? "Quitter le plein écran" : "Passer en plein écran"}
      aria-label={fullscreen ? "Quitter le plein écran" : "Passer en plein écran"}
    >
      <Icon className="h-4 w-4" />
    </button>
  );
};
